(function (root) {
  'use strict';

  const namespace = root.Kate3DPreview = root.Kate3DPreview || {};
  if (namespace.CartService) return;

  const jsonUrl = (url) => url.endsWith('.js') ? url : `${url}.js`;

  class CartService {
    async getAvailableVariantId(product) {
      if (!product?.handle) throw new Error('Invalid product data.');
      const selectedVariant = product.selectedVariant;
      if (selectedVariant?.available && selectedVariant.id) {
        const numericId = String(selectedVariant.id).match(/(\d+)$/)?.[1];
        if (numericId) return Number(numericId);
      }

      const routesRoot = root.Shopify?.routes?.root || '/';
      const response = await fetch(`${routesRoot}products/${product.handle}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Unable to load ${product.title || product.handle}.`);

      const productData = await response.json();
      const availableVariant = productData.variants?.find((variant) => variant.available);
      if (!availableVariant) throw new Error(`${product.title || product.handle} has no available variants.`);
      return availableVariant.id;
    }

    async addCombo(wallProduct, floorProduct, attribution = {}) {
      const [wallVariantId, floorVariantId] = await Promise.all([
        this.getAvailableVariantId(wallProduct),
        this.getAvailableVariantId(floorProduct),
      ]);
      const routesRoot = root.Shopify?.routes?.root || '/';
      const cartAddUrl = jsonUrl(root.themeVariables?.routes?.cartAddUrl || `${routesRoot}cart/add`);
      const comboGroup = `3d_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
      const comboSource = attribution.source || '3d_preview';
      const comboPath = attribution.path || '3d_preview';
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id: wallVariantId,
              quantity: 1,
              properties: {
                _combo_source: comboSource,
                _combo_path: comboPath,
                _combo_group: comboGroup,
                _combo_floor_handle: floorProduct.handle,
              },
            },
            {
              id: floorVariantId,
              quantity: 1,
              properties: {
                _combo_source: comboSource,
                _combo_path: comboPath,
                _combo_group: comboGroup,
                _combo_backdrop_handle: wallProduct.handle,
              },
            },
          ],
          sections: ['mini-cart'],
        }),
      });

      const addResponse = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(addResponse.description || addResponse.message || 'Unable to add this combination to the cart.');
      }
      await this.refreshThemeCart(addResponse);
      return addResponse;
    }

    async refreshThemeCart(addResponse) {
      const routesRoot = root.Shopify?.routes?.root || '/';
      const cartUrl = jsonUrl(root.themeVariables?.routes?.cartUrl || `${routesRoot}cart`);
      const response = await fetch(cartUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('The products were added, but the cart could not be refreshed.');

      const cart = await response.json();
      cart.sections = addResponse.sections || {};
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart,
          openMiniCart: root.themeVariables?.settings?.cartType === 'drawer',
        },
      }));
    }

    notify(element, status, error = '') {
      element.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true,
        cancelable: true,
        detail: { status, error },
      }));
    }
  }

  namespace.CartService = CartService;
})(window);
